export default "__VITE_ASSET__BxWndF9i__"